import { FC } from "react";
import { Box, Card, Flex, Skeleton, Spinner, Text } from "@radix-ui/themes";

/**
 * Loader component the global leaderboard table.
 *
 * @component
 * @returns {JSX.Element} The rendered GlobalLeaderboardTableLoader component.
 */

const GlobalLeaderboardTableLoader: FC = (): JSX.Element => {
  return (
    <Box>
      <Flex justify="start">
        <Text size="2" color="gray" mb="2">
          Updating ...
        </Text>
      </Flex>
      <Flex direction="column" gap="3">
        {Array.from(Array(3), (_, ind) => {
          return (
            <Skeleton loading key={ind}>
              <Card style={{ minHeight: "64px" }} />
            </Skeleton>
          );
        })}
      </Flex>
    </Box>
  );
};

export default GlobalLeaderboardTableLoader;
